<template>
  <!-- TODO: div into checkbox or radio and use v-model -->
  <div
    :id="multipleChoiceId"
    class="multiple-choice__container">
    <div
      v-if="hasError === true"
      class="ui negative small message">
      <div>
        Please choose 1 option.
      </div>
    </div>

    <div
      v-for="(choice, key) in choices"
      :key="key"
      :class="{'state-unselected': !isSelectedList[key], 'state-selected': isSelectedList[key]}"
      class="multiple-choice__button"
      @click="setSelectedValuesModel(choice.label);">
      <i
        v-if="isSelectedList[key] && allowMultiple"
        style="float: right;"
        class="check icon"/>
      <span>
        {{ choice.label }}
      </span>
    </div>

    <div
      v-if="allowOtherChoice === true && currentOtherChoice"
      :id="otherChoiceId">
      <h4>{{ otherText }}</h4>
      <div class="div--outline">
        <div class="input-text">
          {{ currentOtherChoice }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MultipleChoice',
  props: {
    readOnly: {
      type: Boolean,
      default: true
    },
    question: {
      type: Object,
      required: true,
      default: function () {
        return null
      }
    },
    answer: {
      type: null,
      required: false,
      default: function () {
        return null
      }
    }
  },
  data () {
    return {
      selectedValuesModel: [],
      referencesModel: [],
      hasError: false,
      hasOtherChoice: false,
      otherChoiceModel: '',
      otherChoice: '',
      multipleChoiceId: 'multiple-choice-' + this._uid,
      otherChoiceId: 'other-choice-' + this._uid,
      inputTextId: 'input-text-' + this._uid
    }
  },
  computed: {
    questionId: function () {
      return this.question.id
    },
    choices: function () {
      return this.question.properties.choices || []
    },
    selectedValues: function () {
      let selectedValues = null
      if (this.answer) {
        if (this.answer.choices && this.answer.choices.labels) {
          selectedValues = this.answer.choices.labels
        } else if (this.answer.choice && this.answer.choice.label) {
          selectedValues = [this.answer.choice.label]
        }
        return selectedValues
      }
    },
    currentOtherChoice: function () {
      let currentOtherChoice = null
      if (this.answer) {
        if (this.answer.choices && this.answer.choices.other) {
          currentOtherChoice = this.answer.choices.other
        } else if (this.answer.choice && this.answer.choice.other) {
          currentOtherChoice = this.answer.choice.other
        }
      }
      return currentOtherChoice
    },
    allowMultiple: function () {
      return this.question.properties.allow_multiple_selection || false
    },
    allowOtherChoice: function () {
      return this.question.properties.allow_other_choice || false
    },
    otherText: function () {
      return this.$t('patients.profile.objectives.other')
    },
    customPlaceholder: function () {
      return this.question.properties.custom_placeholder || ''
    },
    isSelectedList: function () {
      let isSelectedList = []
      let isSelected = false
      this.choices.forEach(choice => {
        this.selectedValuesModel.forEach(selectedValueModel => {
          if (choice.label === selectedValueModel) {
            isSelected = true
          }
        })
        isSelectedList.push(isSelected)
        isSelected = false
      })
      return isSelectedList
    },
    buildReferences: function () {
      let references = []
      this.choices.forEach(choice => {
        this.selectedValuesModel.forEach(selectedValueModel => {
          if (choice.label === selectedValueModel) {
            references.push(choice.ref)
          }
        })
      })
      return references
    },
    buildAnswerFormat: function () {
      let answer = {}
      if (this.allowMultiple === true) {
        if (this.hasOtherChoice === true) {
          answer = {
            'type': 'choices',
            'references': this.buildReferences,
            'choices': {
              'labels': this.selectedValuesModel,
              'other': this.otherChoice
            },
            'field': {
              'id': this.questionId,
              'type': 'multiple_choice'
            }
          }
        } else {
          answer = {
            'type': 'choices',
            'references': this.buildReferences,
            'choices': {
              'labels': this.selectedValuesModel
            },
            'field': {
              'id': this.questionId,
              'type': 'multiple_choice'
            }
          }
        }
      } else {
        if (this.hasOtherChoice === true) {
          answer = {
            'type': 'choice',
            'choice': {
              'other': this.otherChoice
            },
            'field': {
              'id': this.questionId,
              'type': 'multiple_choice'
            }
          }
        } else {
          answer = {
            'type': 'choice',
            'references': this.buildReferences,
            'choice': {
              'label': this.selectedValuesModel[0]
            },
            'field': {
              'id': this.questionId,
              'type': 'multiple_choice'
            }
          }
        }
      }
      return answer
    }
  },
  watch: {
    isSelectedList (newValue) {
      // TODO: Decide which of the following if condition is more robust
      if (this.$route.name.includes('Recurring') || this.$route.name.includes('Baseline')) {
      // if (this.$route.name !== 'PatientAssessments') {
        this.setAnswer()
      }
    },
    selectedValues (values) {
      if (values) {
        this.selectedValuesModel = this.selectedValues
      }
    },
  },
  mounted () {
    if (this.selectedValues) { // selectedValuesModel = selectedValues
      this.selectedValuesModel = this.selectedValues
    }
    if (this.currentOtherChoice) {
      this.hasOtherChoice = true
      this.otherChoice = this.currentOtherChoice
      this.otherChoiceModel = this.otherChoice
    }
  },
  deactivated () {
    this.$set(this, 'selectedValuesModel', [])
    this.hasError = false
    this.hasOtherChoice = false
  },
  methods: {
    setSelectedValuesModel: function (value) {
      if (this.readOnly) return
      if (value) {
        let index = 0
        let isSelected = false
        if (this.allowMultiple === true) {
          this.selectedValuesModel.forEach(selectedValueModel => {
            if (value === selectedValueModel) {
              this.selectedValuesModel.splice(index, 1)
              isSelected = true
            }
            index++
          })
          if (isSelected === false) {
            this.selectedValuesModel.push(value)
          }
        } else if (this.allowMultiple === false) {
          if (this.selectedValuesModel.length !== 0 && this.selectedValuesModel[0] === value) {
            this.selectedValuesModel = []
          } else {
            this.selectedValuesModel = [value]
          }
          if (this.hasOtherChoice === true) {
            this.hasOtherChoice = false
            this.otherChoiceModel = ''
            this.otherChoice = this.otherChoiceModel
          }
        }
      } else {
        this.hasError = true
      }
    },
    isAnswerValid: function () {
      return new Promise((resolve, reject) => {
        this.hasError = false
        if (!this.questionId || !this.selectedValuesModel) {
          this.hasError = true
          this.$emit('invalidAnswer')
        } else if (this.hasOtherChoice === true && this.otherChoiceModel) {
          this.hasError = true
          this.$emit('invalidAnswer')
        } else if (this.allowMultiple === false && (this.selectedValuesModel.length !== 1 && this.hasOtherChoice === false)) {
          this.hasError = true
          this.$emit('invalidAnswer')
        } else if (this.allowMultiple === true && (this.selectedValuesModel.length > this.choices.length || (this.selectedValuesModel.length === 0 && this.hasOtherChoice === false))) {
          this.hasError = true
          this.$emit('invalidAnswer')
        }
        resolve()
      })
    },
    setAnswer: function () {
      this.isAnswerValid().then(() => {
        this.setSelectedValue()
      })
    },
    setSelectedValue: function () {
      if (this.$route.name !== 'ReadOnlyAssessment') {
        this.$emit('save', this.buildAnswerFormat)
      }
    }
  }
}
</script>

<style scoped>
.multiple-choice__container {
  width: 100%;
  margin: 0.875rem 0;
}

.multiple-choice__helper-text {
  font-style: italic;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
}

.multiple-choice__button {
  width: 100%;
  padding: 0.875rem;
  margin: 0.875rem 0;
  font-size: 1.28571429rem;
  border-radius: 0.28571429rem;
  overflow: hidden;
}

.state-unselected {
  background-color: white;
  box-shadow: 0 0 0 2px #6496bb inset;
  color: #6496bb;
  font-weight: 300;
}

.state-selected {
  border: none;
  background-color: #6496bb;
  box-shadow: 0 0 0 2px #6496bb inset;
  color: white;
  font-weight: 700;
}

.div--outline {
  width: 100%;
  margin: 0.875rem 0;
  position: relative;
  box-shadow: 0 0 0 2px #6496bb inset;
  border-radius: 0.28571429rem;
}

.input-text {
  width: 100%;
  padding: 0.875rem;
  padding-right: 4rem;
  background-color: transparent;
  font-size: 1.28571429rem;
  color: #6496bb;
  border: none;
}

.button__submit {
  width: 100%;
  padding: 0.875rem;
  margin: 0.875rem 0;
  font-size: 1.28571429rem;
  border-radius: 0.28571429rem;
  overflow: hidden;
  border: none;
  background-color: #6496bb;
  color: white;
  font-weight: 500;
}

.button__submit--small {
  padding: 0 0.875rem;
  position: absolute;
  top: 0.28571429rem;
  right: 0.28571429rem;
  bottom: 0.28571429rem;
  border: none;
  border-radius: 0.28571429rem;
  background-color: #6496bb;
  color: white;
  font-weight: 700;
}

input[type='text']:focus,
.multiple-choice__button:focus,
.button__submit:focus,
.button__submit--small:focus {
  outline: none;
}
</style>
